import { Component, EventEmitter, inject, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { Asset } from 'src/app/components/models/asset.model';
import { PaymentStore } from '../../store/payment-report.store';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-crypto-select',
  imports: [CommonModule, FormsModule, MatIconModule, TranslateModule, MatTooltip],
  templateUrl: './crypto-select.component.html',
})
export class CryptoSelectComponent implements OnChanges {
  @Input() cryptoOptions: Asset[] = [];
  @Input() inputId: string = '';
  @Input() alreadySelectedCrypto: string = '';
  @Output() emitSelectEvent = new EventEmitter<string>();

  selectedCrypto: string = '';
  protected paymentStore = inject(PaymentStore);

  ngOnChanges(changes: SimpleChanges): void {
    // Initialize or update selectedCrypto when inputs change
    if ((changes['cryptoOptions'] || changes['alreadySelectedCrypto']) && this.cryptoOptions?.length) {
      this.selectedCrypto = this.alreadySelectedCrypto || this.cryptoOptions[0]?.assetTicker || '';
    }
  }

  hasFiatCurrencies(): boolean {
    return this.cryptoOptions.some((asset) => asset.isFiat);
  }

  hasCryptoAssets(): boolean {
    return this.cryptoOptions.some((asset) => !asset.isFiat);
  }

  onSelectionChange(value: string): void {
    this.selectedCrypto = value;
    this.emitSelectEvent.emit(value);
  }

  getFiatAssets(): Asset[] {
    return this.cryptoOptions.filter((asset) => asset.isFiat);
  }

  getCryptoAssets(): Asset[] {
    return this.cryptoOptions.filter((asset) => !asset.isFiat);
  }
}
